import React from 'react';
import Icon from '../../../components/AppIcon';
import ToolCard from './ToolCard';

const CategorySection = ({ category, tools, onRequestAccess }) => {
  const getCategoryIcon = (categoryName) => {
    switch (categoryName?.toLowerCase()) {
      case 'communication':
        return 'MessageSquare';
      case 'development':
        return 'Code';
      case 'productivity':
        return 'Zap';
      case 'design':
        return 'Palette';
      case 'analytics':
        return 'BarChart3';
      default:
        return 'Package';
    }
  };

  return (
    <div className="mb-8">
      <div className="flex items-center gap-3 mb-4">
        <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
          <Icon name={getCategoryIcon(category)} size={20} color="var(--color-primary)" strokeWidth={2} />
        </div>
        <div>
          <h2 className="text-xl font-bold text-foreground">{category}</h2>
          <p className="text-sm text-muted-foreground">{tools?.length} tools available</p>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {tools?.map((tool) => (
          <ToolCard key={tool?.id} tool={tool} onRequestAccess={onRequestAccess} />
        ))}
      </div>
    </div>
  );
};

export default CategorySection;